import React from "react";
import styled from "styled-components";

const Gallery = ({ data = {} }) => {
  const { title = "Book A Space", subtitle = "Find the perfect workspace for your needs", items = [] } = data;

  return (
    <GallerySection>
      <GalleryHeader>
        <GalleryTitle>{title}</GalleryTitle>
        <GallerySubtitle>{subtitle}</GallerySubtitle>
      </GalleryHeader>

      <GalleryGrid>
        {items.map((item, index) => (
          <GalleryCard key={index}>
            <GalleryImageContainer>
              <GalleryImage src={item.image} alt={item.title} />
            </GalleryImageContainer>
            <GalleryContent>
              <GalleryCardTitle>{item.title}</GalleryCardTitle>
              <GalleryCardDescription>{item.description}</GalleryCardDescription>
            </GalleryContent>
          </GalleryCard>
        ))}
      </GalleryGrid>
    </GallerySection>
  );
};

export default Gallery;

const GallerySection = styled.section`
  padding: 80px 80px 80px 80px;
  @media (max-width: 768px) { padding: 60px 0; }
`;

const GalleryHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
  padding: 0 20px;
`;

const GalleryTitle = styled.h2`
  font-size: 48px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 16px;
  @media (max-width: 768px) { font-size: 36px; }
`;

const GallerySubtitle = styled.p`
  font-size: 20px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  @media (max-width: 768px) { font-size: 18px; }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 0 auto;
  padding: 0 20px;
  @media (max-width: 1024px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 40px; }
`;

const GalleryCard = styled.div`
  background: white;
  border-radius: 25px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
`;

const GalleryImageContainer = styled.div`
  height: 250px;
  overflow: hidden;
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 25px 25px 25px 25px;
  transition: transform 0.5s ease;
`;

const GalleryContent = styled.div`
  padding: 30px 30px 30px 0px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 250px);
`;

const GalleryCardTitle = styled.h3`
  font-size: 24px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 15px;
  @media (max-width: 768px) { font-size: 22px; }
`;

const GalleryCardDescription = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 25px;
  flex-grow: 1;
`;
